import { IAppMessageState } from "message/model"

export function getDefaultMessageState(): IAppMessageState {
  return {
    messages: [],
    overlayMessages: [],
    confirmMessage: undefined
  }
}
